import { render, staticRenderFns } from "./CreateBoardDlg.vue?vue&type=template&id=7305b4b9"
import script from "./CreateBoardDlg.vue?vue&type=script&lang=js"
export * from "./CreateBoardDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports